import Approute from "./router/Index";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import WebSocketSessionHandler from "./components/WebSocketSessionHandler";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || "547484151794-tbj5l4rhn7lc5ro4c2o59nvp0mt1bql8.apps.googleusercontent.com";

export default function App(){
  return(
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <WebSocketSessionHandler />
        <Approute/>
      </BrowserRouter>
    </GoogleOAuthProvider>
  )
}